import theme, { COLORS, SPACING, SHADOWS, BORDER_RADIUS } from './theme.js';

export const useTheme = () => {
  return {
    colors: COLORS,
    spacing: SPACING,
    shadows: SHADOWS,
    borderRadius: BORDER_RADIUS,
    theme,
  };
};

export const spacing = (value) => {
  if (typeof value === 'number') {
    return value * SPACING.md;
  }
  return SPACING[value] || SPACING.md;
};

export const getShadow = (level = 'md') => {
  if (typeof SHADOWS === 'undefined' || !SHADOWS) {
    return {};
  }
  return SHADOWS[level] || SHADOWS.md || {};
};

export const getColor = (path) => {
  if (!path) return COLORS.primary.main;
  const parts = path.split('.');
  return parts.reduce((obj, part) => obj?.[part], COLORS) || COLORS.primary.main;
};

export const getBorderRadius = (size = 'md') => BORDER_RADIUS[size];
